// #region License

/**
 * @license
 * Copyright (C) Mairistem
 *
 * Unauthorized copying of this file, via any medium is strictly prohibited.
 *
 * Proprietary and confidential
 */

// #endregion

import * as React from "react";
import { Button, Popup } from "semantic-ui-react";
import "./ApplicationListItemAction.less";
import { getApplicationClassName, getClassName } from "../utils/className";
import { jsx as _jsx } from "react/jsx-runtime";
export const ApplicationListItemAction = props => {
  const {
    className,
    content,
    icon,
    title,
    titlePosition,
    disabled,
    loading,
    onClick,
    onMouseDown
  } = props;
  const handleClick = React.useCallback(event => {
    onClick?.(event, props);
    event.preventDefault();
    event.stopPropagation();
  }, [onClick, props]);
  const handleMouseDown = React.useCallback(event => {
    onMouseDown?.(event);
    event.preventDefault();
    event.stopPropagation();
  }, [onMouseDown]);
  const triggerComponent = React.useMemo(() => /*#__PURE__*/_jsx(Button, {
    className: getClassName(className, getApplicationClassName("list", "item", "action")),
    "aria-label": title,
    content: content,
    icon: icon,
    disabled: disabled,
    loading: loading,
    onClick: handleClick,
    onMouseDown: handleMouseDown
  }), [className, content, icon, title, disabled, loading, handleClick, handleMouseDown]);
  const contentComponent = React.useMemo(() => title, [title]);
  return React.useMemo(() => /*#__PURE__*/_jsx(Popup, {
    position: titlePosition || "bottom left",
    trigger: triggerComponent,
    content: contentComponent,
    mouseEnterDelay: 2000
  }), [contentComponent, triggerComponent, titlePosition]);
};